import React from 'react'
import AssessmentTable from './AssessmentTable'

function Closed({globalReset,filterIntake,filterLearningMethod,filterSchool,filterLecturer}) {
  return <AssessmentTable globalReset={globalReset} filterIntake={filterIntake} filterLearningMethod={filterLearningMethod} filterLecturer={filterLecturer} filterSchool={filterSchool}/>
}

export default Closed